import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    monthly: {
        borderTop: '12px solid #B897BF',
        '& .MuiTypography-h5': {
            color: '#B897BF',
        },
    },
    yearly: {
        borderTop: '12px solid #41756F',
        '& .MuiTypography-h5': {
            color: '#41756F',
        },
    },
}));

export default useStyles;
